import React, { useState, useEffect } from 'react';
import apinode from '../../services/apinode';
import Navbar from '../../components/navbar/navbar'

const PedidosList = () => {
    const hoje = new Date();
    const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
        .toISOString()
        .split('T')[0];
    const dataHoje = hoje.toISOString().split('T')[0];

    const [pedidos, setPedidos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [importando, setImportando] = useState(null); // controla o loading de importação
    const [filtros, setFiltros] = useState({
        dataInicial: primeiroDiaMes,
        dataFinal: dataHoje,
        idLoja: '203404410',
        idPedido: ''
    });

    const fetchPedidos = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await apinode.get(`/bling/listar/pedido/${localStorage.idconta || 0}`, {
                params: {
                    dataInicial: filtros.dataInicial,
                    dataFinal: filtros.dataFinal,
                    idLoja: filtros.idLoja
                }
            });

            const data = Array.isArray(response.data) ? response.data : [response.data];
            setPedidos(data);
        } catch (err) {
            setError(`Erro ao buscar pedidos: ${err.message}`);
            console.error('Erro na requisição:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
       // fetchPedidos();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchPedidos();
    };

    const handleImport = async (pedido) => {
        try {
            setImportando(pedido.id);

            // chama backend para buscar + importar no banco
            const response = await apinode.post(`/bling/import/pedido/${localStorage.idconta || 0}`, {
                id: pedido.id
            });

            alert(`Pedido ${pedido.numero} importado com sucesso!`);
            console.log('Importação concluída:', response.data);
        } catch (err) {
            console.error(err);
            alert(`Erro ao importar pedido ${pedido.numero}`);
        } finally {
            setImportando(null);
        }
    };

    const formatarData = (data) => {
        if (!data) return '-';
        return new Date(data).toLocaleDateString('pt-BR');
    };

    const formatarMoeda = (valor) => {
        if (!valor) return 'R$ 0,00';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    const getSituacaoBadge = (situacaoId) => {
        switch (situacaoId) {
            case 1: return { class: 'bg-warning text-dark', text: 'Pendente' };
            case 2: return { class: 'bg-info', text: 'Em Processamento' };
            case 3: return { class: 'bg-primary', text: 'Em Produção' };
            case 4: return { class: 'bg-secondary', text: 'Enviado' };
            case 5: return { class: 'bg-success', text: 'Entregue' };
            case 6: return { class: 'bg-success', text: 'Confirmado' };
            case 7: return { class: 'bg-danger', text: 'Cancelado' };
            default: return { class: 'bg-secondary', text: `Situação ${situacaoId}` };
        }
    };

    return (
        <>
            < Navbar />

            <div className="container-fluid py-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <div className="row">
                    <div className="col-12">
                        <div className="card shadow-lg" style={{ borderRadius: '15px', border: 'none' }}>
                            <div
                                className="card-header text-white"
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    borderRadius: '15px 15px 0 0'
                                }}
                            >
                                <h4 className="mb-0">
                                    <i className="fas fa-shopping-cart me-2"></i>
                                    Consulta de Pedidos - Bling API
                                </h4>
                            </div>

                            <div className="card-body p-4">
                                {/* Filtros */}
                                <div className="bg-light p-4 rounded mb-4">
                                    <h5 className="mb-3">
                                        <i className="fas fa-filter me-2"></i>
                                        Filtros de Pesquisa
                                    </h5>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label fw-bold">
                                                    <i className="fas fa-hashtag me-1"></i>
                                                    ID do Pedido
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg"
                                                    name="idPedido"
                                                    value={filtros.idPedido}
                                                    onChange={handleInputChange}
                                                    placeholder="514066249"
                                                    style={{ borderRadius: '10px' }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-bold">
                                                    <i className="fas fa-calendar-alt me-1"></i>
                                                    Data Inicial
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-lg"
                                                    name="dataInicial"
                                                    value={filtros.dataInicial}
                                                    onChange={handleInputChange}
                                                    style={{ borderRadius: '10px' }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-bold">
                                                    <i className="fas fa-calendar-check me-1"></i>
                                                    Data Final
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-lg"
                                                    name="dataFinal"
                                                    value={filtros.dataFinal}
                                                    onChange={handleInputChange}
                                                    style={{ borderRadius: '10px' }}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-bold">
                                                    <i className="fas fa-store me-1"></i>
                                                    ID da Loja
                                                </label>

                                                <select
                                                    className="form-control form-control-lg"
                                                    name="idLoja"
                                                    value={filtros.idLoja}
                                                    onChange={handleInputChange}
                                                    style={{ borderRadius: '10px' }}
                                                >
                                                    <option value="">Selecione...</option>
                                                    <option value="203404410">Amazon (203404410)</option>
                                                    <option value="205745515">AmazonFBAClassic (205745515)</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg px-4"
                                                    disabled={loading}
                                                    style={{ borderRadius: '25px' }}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Carregando...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-search me-2"></i>
                                                            Buscar Pedidos
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                {/* Tabela */}
                                {!loading && !error && pedidos.length > 0 && (
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                    <th>ID</th>
                                                    <th>Números do Pedido</th>
                                                    <th>Datas</th>
                                                    <th>Contato</th>
                                                    <th>Situação</th>
                                                    <th>Valores</th>
                                                    <th>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pedidos.map((pedido, index) => {
                                                    const situacao = getSituacaoBadge(pedido.situacao?.id);
                                                    return (
                                                        <tr key={pedido.id || index}>
                                                            <td><span className="badge bg-dark fs-6">{pedido.id}</span></td>
                                                            <td>
                                                                <div>
                                                                    <span className="badge bg-primary mb-1">#{pedido.numero}</span>
                                                                    {pedido.numeroLoja && (
                                                                        <div><small className="text-muted"><i className="fas fa-store me-1"></i>{pedido.numeroLoja}</small></div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <div className="fw-bold text-primary">
                                                                        <i className="fas fa-calendar-day me-1"></i>
                                                                        {formatarData(pedido.data)}
                                                                    </div>
                                                                    {pedido.dataSaida && (
                                                                        <small className="text-muted d-block"><i className="fas fa-shipping-fast me-1"></i>Saída: {formatarData(pedido.dataSaida)}</small>
                                                                    )}
                                                                    {pedido.dataPrevista && (
                                                                        <small className="text-success d-block"><i className="fas fa-clock me-1"></i>Prev.: {formatarData(pedido.dataPrevista)}</small>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <div className="fw-bold">
                                                                        <i className="fas fa-user-circle me-1"></i>
                                                                        {pedido.contato?.nome || '-'}
                                                                    </div>
                                                                    {pedido.contato?.numeroDocumento && (
                                                                        <small className="text-muted d-block">
                                                                            <i className={`fas ${pedido.contato.tipoPessoa === 'F' ? 'fa-id-card' : 'fa-building'} me-1`}></i>
                                                                            {pedido.contato.tipoPessoa === 'F' ? 'CPF' : 'CNPJ'}: {pedido.contato.numeroDocumento}
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td><span className={`badge ${situacao.class}`}>{situacao.text}</span></td>
                                                            <td>
                                                                <div className="fw-bold text-success fs-6">{formatarMoeda(pedido.total)}</div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex gap-1">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-success btn-sm"
                                                                        onClick={() => handleImport(pedido)}
                                                                        disabled={pedido.importado || importando === pedido.id}
                                                                    >
                                                                        {importando === pedido.id ? (
                                                                            <span className="spinner-border spinner-border-sm"></span>
                                                                        ) : (
                                                                            <i className="fas fa-download"></i>
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {!loading && !error && pedidos.length === 0 && (
                                    <div className="text-center py-5">
                                        <i className="fas fa-inbox text-muted" style={{ fontSize: '4rem' }}></i>
                                        <h5 className="text-muted mt-3">Nenhum pedido encontrado</h5>
                                        <p className="text-muted">Tente ajustar os filtros de pesquisa ou verificar a conexão com a API.</p>
                                    </div>
                                )}

                                {error && (
                                    <div className="alert alert-danger d-flex align-items-center" role="alert">
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        <div>{error}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PedidosList;
